<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div>
      <v-card flat>
        <v-card-text v-if="!isEditEnabled">
          <v-btn
              class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
              @click="EnableEdit"
          >Edit
          </v-btn
          >
          <div class="flex my-4 mb-4">
            <!-- <div class="w-1/3 h-12 required"> -->
            <div class="w-full md:w-1/2 px-3 mb-6">
              <label
                  class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
              >Score</label
              >
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6">
              <label
                  class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
              >{{ values.score }}</label
              >
            </div>
          </div>
          <div class="flex my-4 mb-4">
            <!-- <div class="w-1/3 h-12"> -->
            <div class="w-full md:w-1/2 px-3 mb-6">
              <label
                  class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
              >Course Completion Date</label
              >
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6">
              <label
                  class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
              >{{ values.courseCompletionDate }}</label
              >
            </div>
          </div>
          <div class="flex my-4 mb-4">
            <div class="w-full md:w-1/2 px-3 mb-6">
              <label
                  class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
              >Status</label
              >
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6">
              <label
                  class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
              >{{ values.traineStatusIds == passId ? "Pass" : "Fail" }}</label
              >
            </div>
          </div>
        </v-card-text>
        <v-card-text v-else>
          <div v-if="loading" class="text-center">
            <v-progress-circular
                color="primary"
                indeterminate
            ></v-progress-circular>
          </div>
          <div class="flex my-4 mb-4">
            <!-- <div class="w-1/3 h-12 required"> -->
            <div class="w-full md:w-1/2 px-3 mb-6 required">
              <label
                  class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
              >Score</label
              >
              <!-- </div> -->
              <!-- <p class="text-md-left font-weight-bold">Score:</p> -->
              <!-- <p
              v-if="validation.negativeScoreError"
              class="text-md-left font-weight-bold red"
            >
              * Score can't be negative or more than 100
            </p>
            <p
              v-else-if="validation.scoreNullError"
              class="text-md-left font-weight-bold red"
            >
              * Score can't be null
            </p> -->
            </div>
            <div class="w-1/3 h-12">
              <validation-provider
                  v-slot="{ errors }"
                  rules="required|min_value:0|max_value:100"
              >
                <input
                    v-model="values.score"
                    class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                    name
                    placeholder="add score here"
                    type="number"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="flex my-4 mb-4">
            <!-- <div class="w-1/3 h-12"> -->
            <div class="w-full md:w-1/2 px-3 mb-6 required">
              <label
                  class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
              >Course Completion Date</label
              >
            </div>
            <!-- <p class="text-md-left font-weight-bold">*Course Completion Date:</p> -->
            <!-- </div> -->
            <div class="w-1/3 h-12">
              <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="values.courseCompletionDate"
                  min-width="auto"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="values.courseCompletionDate"
                      label="course completion date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="values.courseCompletionDate"
                    :max="date"
                    no-title
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                      color="primary"
                      text
                      @click="$refs.menu.save(values.courseCompletionDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
          <div class="flex my-4 mb-4">
            <div class="w-full md:w-1/2 px-3 mb-6 required">
              <label
                  class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
              >Score</label
              >
              <!-- <p
              v-if="validation.statusNullError"
              class="text-md-left font=weight-bold red"
            >
              *Status can't be null
            </p> -->
            </div>
            <div class="w-1/3 h-12">
              <validation-provider v-slot="{ errors }" rules="required">
                <input
                    id="pass"
                    v-model="values.traineeStatusId"
                    :value="passId"
                    class="my-3 ml-5"
                    type="radio"
                />
                <label for="pass"> Pass </label>
                <br/>
                <input
                    id="fail"
                    v-model="values.traineeStatusId"
                    :value="failId"
                    class="my-3 ml-5"
                    type="radio"
                />
                <label for="fail"> Fail </label>
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="d-flex flex-row-reverse">
            <div class="w-1/3 h-12">
              <div class="d-flex flex-row-reverse space-around">
                <v-btn
 v-if="$can('trainee', 'completeTraining')"                    :disabled="!(values.traineeStatusId == passId)"
                    class="teal white--text"
                    color="primary"
                    depressed
                    small
                    @click="updateCoursePasss(values, 'pass')"
                >
                  Submit for Approval
                </v-btn>
                <v-btn
 v-if="$can('trainee', 'completeTraining')"                    :disabled="!(values.traineeStatusId == failId)"
                    class="teal white--text"
                    color="primary"
                    depressed
                    small
                    @click="updateCoursePasss(values, 'fail')"
                >
                  <span>update</span>
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {TraineeService} from "../trainees.service";
import {generateCertificate1} from "../generate-certiificate";
import {isCertificateApprovalComplete} from "@/utils/helper";
import {router} from "@/router";
import {moment} from "moment";
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {max_value, min_value, required} from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("min_value", {
  ...min_value,
  message: "Score can't be negative",
});
extend("max_value", {
  ...max_value,
  message: "Score can't be more than 100",
});

export default {
  props: {
    traineeUpdateCourseDetail: Object,
    traineeStatus: Array,
    courseCompletionDialog: Boolean,
    userInfo: Object,
    traineeType: String,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      moment: () => moment,
      values: {},
      validation: {
        negativeScoreError: false,
        scoreNullError: false,
        statusNullError: false,
      },
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      passId: "",
      failId: "",
      updateDisabled: true,
      generateDisabled: true,
      isEditEnabled: false,
      loading: false,
      isCategory1: null,
    };
  },
  methods: {
    EnableEdit() {
      this.isEditEnabled = true;
    },
    async updateCoursePasss(v, status) {
      if (v.score < 0 || v.score > 100) {
        this.validation.negativeScoreError = true;
      } else if (v.score == null || v.score == "") {
        this.validation.scoreNullError = true;
      } else if (v.traineeStatusId == null) {
        this.validation.statusNullError = true;
      } else {
        this.loading = true;
        this.validation.scoreNullError = false;
        this.validation.negativeScoreError = false;
        this.validation.statusNullError = false;
        const params = {
          ...v,
        };
        if (status === "pass") {
          params.certificateApprovalStatus = "PENDING";
        } else {
          params.certificateApprovalStatus = null;
        }
        if (this.traineeType == "new") {
          if (this.isCategory1 == true) {
            const res = await TraineeService.completeNewTraineeCourse(params);
            this.loading = true;
            if (res.data.status === 200) {
              if (status === "pass") {
                this.$toast.success("Course completed. Certificate pending approval.");
                router.go();
              } else if (status === "fail") {

                router.go();
              }
            }
          } else {
            const res = await TraineeService.completeNewTCat2Course(params);
            this.loading = true;
            if (res.data.status === 200) {
              if (status === "pass") {
                this.$toast.success("Course completed. Certificate pending approval.");
                router.go();
              } else if (status === "fail") {

                router.go();
              }
            }
          }
        } else if (this.traineeType == "old") {
          if (this.isCategory1 == true) {
            const res = await TraineeService.completeTraineeCourse(params);
            this.loading = true;
            if (res.data.status === 200) {
              if (status === "pass") {
                this.$toast.success("Course completed. Certificate pending approval.");
                router.go();
              } else if (status === "fail") {
                router.go();
              }
            }

          } else {
            const res = await TraineeService.completeTraineeCat2Course(params);
            this.loading = true;
            if (res.data.status === 200) {
              if (status === "pass") {
                this.$toast.success("Course completed. Certificate pending approval.");
                router.go();
              } else if (status === "fail") {
                router.go();
              }
            }

          }
        }
      }
    },
    generateCerteficate() {
      if (!isCertificateApprovalComplete(this.traineeUpdateCourseDetail)) {
        this.$toast.warning("Certificate is pending approval.");
        return;
      }
      generateCertificate1(this.traineeUpdateCourseDetail, this.userInfo);
    },
    assignStatusId() {
      this.traineeStatus.map((e) => {
        this.passId = e.code == "PASS" ? e.id : this.passId;
        this.failId = e.code == "FAIL" ? e.id : this.failId;
      });
    },
  },
  created() {
    if (this.traineeUpdateCourseDetail != null) {
      const categoryType = this.traineeUpdateCourseDetail.program.category
          .categoryType;
      categoryType == "CAT1"
          ? (this.isCategory1 = true)
          : (this.isCategory1 = false);
      this.values = this.traineeUpdateCourseDetail;
    }
    this.assignStatusId();
  },
};
</script>
<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}

.v-progress-circular {
  margin: 1rem;
}
</style>
